import { Link } from "@mui/material";

import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import MobileBanner from "public/images/cincinnatireds/25-Attend Seat Upgrade-Images_375x550.png";
import DesktopBanner from "public/images/cincinnatireds/25-Attend Seat Upgrade-Images_1920x450.png";
import OrderSummaryBanner from "public/images/cincinnatireds/25-Attend Seat Upgrade-Images_1920x1080-2.png";

export const cincinnatireds_upgrades_sandbox: TTeamConfig = {
  TEAM_SCHEMA: "cincinnatireds_upgrades_sandbox",
  TEAM_FULL_NAME: "Cincinnati Reds",
  BROWSER_TITLE: "Cincinnati Reds Upgrades",
  CLIENT_ID: "XATXJLZGaKgqGHjcRraofrbPdAfiGn8e",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#C6011F",
    COLORS_SECONDARY: "#000000",
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,
    IS_BALLPARK_APP: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_UPCOMING_EVENTS: true,
      LOGIN_LABEL: "View Upgrades",
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,

    FOOTER: {
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: `${new Date().getFullYear()} ©`,
    },
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      HIDE_SECTION_TITLE: true,
      REGISTRATION_CARDS,
    },

    HIDE_PASSES: true,
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      MOBILE_MAX_HEIGHT: "520px",
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    IS_QUICK_CHECKOUT_ENABLED: true,
    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "list",
      HIDE_NEXT_GAME: true,
      HIDE_EVENT_LOGO: true,
    },

    HIDE_EVENT_BANNER: true,

    ADD_ON: {
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Purchase Confirmed!",
        DESCRIPTION: () => (
          <>
            Thank you for your purchase, your tickets are now available in the
            Ballpark App{" "}
            <Link
              href="https://bp.mlb.com/Wallet"
              sx={{
                color: "white",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              here
            </Link>
            . Please remember your Upgrade ticket cannot be used for entry into
            the venue.
          </>
        ),
      },
      ADD_SERVICE_FEE_TO_PRICE: true,
      HIDE_MAX_COUNT_LABEL: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLE_SAVE_CARD: true,
    },

    ADD_ONS_LABEL: "Upgrade Tickets",
    SERVICE_FEE_LABEL: "Total Per Ticket Fee(s)",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LANDING_PAGE_STATIC_BANNER_URL: DesktopBanner.src,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryBanner.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileBanner.src,
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/CIN-3.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
